/* TanStack Query hook over GET /v1/expense/coa/accounts — the entity's currently-effective,
   postable GL accounts (accounting.account), for the expense line account picker. Entity
   isolation is server-side (RLS); this just reads the caller's own chart of accounts.
   NOTE: the endpoint lives under CoaController (/v1/expense/coa/accounts) — a prior hook URL of
   /v1/expense/accounts had no handler (404 → empty picker → lines couldn't be GL-coded → couldn't
   submit). Caught by the exhaustive expense-full-journey e2e. */
import { useQuery } from '@tanstack/react-query';

import { expenseFetch } from '@/expense/lib/expense-api';

export interface ExpenseAccount {
  accountId: number;
  code: string;
  name: string;
  /** ASSET | LIABILITY | EQUITY | REVENUE | EXPENSE */
  accountType: string;
  /** 'D' | 'C' */
  normalBalance: string;
  postable: boolean;
}

/** P&L account types — the ones an expense line codes against. */
export const PL_ACCOUNT_TYPES = ['EXPENSE', 'REVENUE'] as const;

export function useAccounts() {
  return useQuery({
    queryKey: ['expense', 'accounts'] as const,
    queryFn: () => expenseFetch<ExpenseAccount[]>('/v1/expense/coa/accounts'),
  });
}
